import type { InboxThread } from "@tellescope/types-models";
import { Mail, MessageCircle, Phone, Smartphone } from "lucide-react";
import { cn } from "../lib/utils";
import { getChannelColor } from "../utils";

export interface ChannelIconProps {
  channel: InboxThread["type"];
  className?: string;
  showChannelColor?: boolean; // Option to enable/disable channel coloring
}

export const ChannelIcon = ({ channel, className: providedClassName, showChannelColor = true }: ChannelIconProps) => {
  const color = getChannelColor(channel);
  const className = cn(
    "w-4 h-4 inline-block",
    showChannelColor ? color.iconColor : "text-muted-foreground",
    providedClassName
  );

  switch (channel) {
    case "Phone":
      return <Phone className={className} />;
    case "GroupMMS":
    case "SMS":
      return <Smartphone className={className} />;
    case "Chat":
      return <MessageCircle className={className} />;
    case "Email":
      return <Mail className={className} />;
    case "Zendesk":
      return showChannelColor ? (
        <img
          src="/zd-icon.png"
          className={cn("h-4 w-4 inline-block", providedClassName)}
          style={{ filter: "brightness(0.2)" }}
          alt="Zendesk"
        />
      ) : (
        <img src="/zd-icon.png" className={cn("h-4 w-4 inline-block opacity-50", providedClassName)} alt="Zendesk" />
      );
    default: {
      const _exhaustive: never = channel;
      return null;
    }
  }
};
